// src/core/workbook/security.js

export const initSecurityLayer = (containerElement) => {
  if (!containerElement) return () => {};

  // ۱. غیرفعال‌سازی راست‌کلیک
  const preventContext = (e) => e.preventDefault();
  document.addEventListener('contextmenu', preventContext);

  // ۲. غیرفعال‌سازی میانبرهای کلیدی
  const preventKeys = (e) => {
    const blocked = [
      (e.ctrlKey || e.metaKey) && ['s', 'p', 'u', 'c', 'a'].includes(e.key.toLowerCase()),
      e.key === 'PrintScreen',
      e.key === 'F12',
      (e.ctrlKey || e.metaKey) && e.shiftKey && ['i', 'j', 'c'].includes(e.key.toLowerCase()),
    ];
    if (blocked.some(Boolean)) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  document.addEventListener('keydown', preventKeys, true);

  // ۳. غیرفعال‌سازی کپی
  const preventCopy = (e) => {
    e.preventDefault();
    try { e.clipboardData?.setData('text/plain', 'محتوا محافظت‌شده است'); } catch {}
  };
  document.addEventListener('copy', preventCopy);
  document.addEventListener('cut', preventCopy);

  // ۴. تشخیص DevTools
  let devtoolsOpen = false;
  const checkDevTools = () => {
    const widthDiff = window.outerWidth - window.innerWidth;
    const heightDiff = window.outerHeight - window.innerHeight;
    const isOpen = widthDiff > 160 || heightDiff > 160;
    if (isOpen !== devtoolsOpen) {
      devtoolsOpen = isOpen;
      containerElement.classList.toggle('security-blur', devtoolsOpen);
    }
  };
  const devtoolsInterval = setInterval(checkDevTools, 1000);

  // ۵. Blur در تغییر تب
  const handleBlur = () => containerElement.classList.add('security-blur');
  const handleFocus = () => {
    if (!devtoolsOpen) containerElement.classList.remove('security-blur');
  };
  const handleVisibility = () => {
    if (document.hidden) containerElement.classList.add('security-blur');
    else if (!devtoolsOpen) containerElement.classList.remove('security-blur');
  };

  window.addEventListener('blur', handleBlur);
  window.addEventListener('focus', handleFocus);
  document.addEventListener('visibilitychange', handleVisibility);

  // پاک‌سازی
  return () => {
    document.removeEventListener('contextmenu', preventContext);
    document.removeEventListener('keydown', preventKeys, true);
    document.removeEventListener('copy', preventCopy);
    document.removeEventListener('cut', preventCopy);
    clearInterval(devtoolsInterval);
    window.removeEventListener('blur', handleBlur);
    window.removeEventListener('focus', handleFocus);
    document.removeEventListener('visibilitychange', handleVisibility);
  };
};